export const TrackingPageZone: { [key: string]: string } = {
  firstBanner: 'First Hero',
  secondBanner: 'Second Hero',
  thirdBanner: 'Third Hero',
  fourthBanner: 'Fourth Hero',
  fifthBanner: 'Fifth Hero',
}

export interface CtaTrackingProperties {
  category: string
  label: string
  eventDetail: string
  navigationDetail: string
}

export interface CtaTrackingConfig {
  eventName: string
  properties: CtaTrackingProperties
  linkAttributes: {
    'data-section': string
    'data-position'?: string | number
    'data-translation': string
  }
}
